<script setup>
import { OtomaticAIIcon } from "@Icons/index";
import { onMounted, ref, compile, h } from "vue";

const props = defineProps({
    message: String,
    animate: Boolean,
    messageIndex: Number,
});

const emit = defineEmits(["suggestion-clicked"]);

const tools = ["NewCategory", "Category", "Profile", "Project", "JsonResponse", "SuggestionBox", "ImageGeneration"];
const displayableParts = ref([]);

onMounted(() => {
    let message = props.message;

    // separate message by tools and text
    let regex = new RegExp("(<(?:" + tools.join("|") + ").*?>.*?<\/(?:" + tools.join("|") + ")>)", "is");
    let split = message.split(regex);

    // create parts array with type and content
    let parts = [];
    split.forEach((part) => {
        if (part.match(regex)) {
            parts.push({ type: "tool", content: part });
        } else {
            do {
                let length = Math.floor(Math.random() * 10);
                parts.push({ type: "text", content: part.slice(0, length) });
                part = part.slice(length);
            } while (part.length > 0);
        }
    });

    // if animate, display earch parts with a delay
    if (props.animate) {
        let timer = 0;
        let first = true;
        parts.forEach((part) => {
            if (!first) {
                timer += Math.random() * 50;
            } else {
                first = false;
            }
            setTimeout(() => {
                if (part.type === "tool") {
                    displayableParts.value[displayableParts.value.length] = {
                        type: "component",
                        component: h({ render: compile(part.content) }),
                    };
                    displayableParts.value[displayableParts.value.length] = {
                        type: "text",
                        content: [],
                    };
                } else {
                    if (displayableParts.value.length === 0) {
                        displayableParts.value.push({
                            type: "text",
                            content: "",
                        });
                    }
                    displayableParts.value[displayableParts.value.length - 1].content += part.content;
                }
            }, timer);
        });
    } else {
        parts.forEach((part) => {
            if (part.type === "tool") {
                displayableParts.value[displayableParts.value.length] = {
                    type: "component",
                    component: h({ render: compile(part.content) }),
                };
                displayableParts.value[displayableParts.value.length] = {
                    type: "text",
                    content: [],
                };
            } else {
                if (displayableParts.value.length === 0) {
                    displayableParts.value.push({
                        type: "text",
                        content: "",
                    });
                }
                displayableParts.value[displayableParts.value.length - 1].content += part.content;
            }
        });
    }
});
</script>

<template>
    <div class="flex items-start gap-3">
        <OtomaticAIIcon class="size-6 flex-none" />
        <div class="flex-1 text-sm leading-6 whitespace-pre-wrap">
            <template v-for="(part, index) in displayableParts" :key="index">
                <component v-if="part.type === 'component'" :is="part.component" :message-index="messageIndex" :tool-index="index" />
                <span v-else v-html="part.content"></span>
            </template>
        </div>
    </div>
</template>
